import { getConditionalArray } from 'utils/data';

export const PickerTab = {
  CONDITIONS: 'conditions',
  CONDITION_SETS: 'conditionSets',
  ADHOC: 'adhoc',
};

export const getPickerTabsConfig = ({ isAdhocAllowed }) => [
  { label: 'Conditions', value: PickerTab.CONDITIONS },
  { label: 'Condition Sets', value: PickerTab.CONDITION_SETS },
  ...getConditionalArray(isAdhocAllowed, [{ label: 'Ad-hoc', value: PickerTab.ADHOC }]),
];

export const initialFormValues = {
  conditions: [],
  conditionSets: [],
  conditionTaskTypes: {},
};

export const CONDITION_MESSAGE_MAX_LENGTH = 1000;

export const MODAL_TITLE = 'Add conditions and condition sets';

export const NEW_FORM_DIALOG_HEADER = 'Create new loan specific form';
